export
const name: string = "SsaoGeometry";

export
const preproc: string = ``;

export
const declaration: string = ``;

export
const varyings: string = `
	varying vec3 	v_position;
	varying float 	v_visibility;
`;

export
const implementation: string = `
	void main(void)
	{
		if (v_visibility < 0.5) {
			discard;
		}

	#ifdef CLIPPING_PLANE
        if (resolveClippingPlane()) {
            #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)

            discard;

            #endif
        }
    #endif

	    gl_FragColor = vec4(v_position, 1.0);

	#ifdef LOGDEPTH
	    resolveLogarithmicDepth();
	#endif
	}
`;
